<template>
  <b-container id="verify-match-container" class="d-flex flex-column">
    <div id="verify-match-title-container" class="row pt-md-3 pt-2">
      <div class="col-12 col-md-6 d-flex justify-content-center">
        <div class="custom-width ml-md-5 justify-content-between d-md-flex align-items-center">
          <back-arrow :body-modal="$t('verify.match.quit.dialog.description')"
                      :confirm="true"
                      :title="$t('verify.match.page.header.title')"
                      :title-modal="$t('verify.match.quit.dialog.title')"
          />
        </div>
      </div>
    </div>

    <div id="verify-match-sub-container" class="row pt-md-5 pt-2">
      <div id="verify-match-sub-container-left" class="col-12 col-md-6 col-title">
        <div class="custom-width ml-md-5 d-flex align-items-center">
          <h1 class="page-title w-75">
            {{ $t('verify.match.page.title') }}</h1>
        </div>
        <div class="custom-width ml-md-5 mt-3"><h1 class="content">
          {{ $t('verify.match.page.subtitle') }}</h1></div>
      </div>

      <div id="verify-match-sub-container-right"
           class="col-12 col-md-6 d-flex justify-content-center justify-content-md-start">

        <verify-match-step1
          v-if="currentStep===1"
          :imageInvalidState="imagesInvalidState"
          :vehicle-files-saved="vehicleFiles"
          @updateSelectedPhotos="onVehicleFilesUpdated"
        ></verify-match-step1>

        <verify-match-step2
          v-if="currentStep===2"
          :identifier="identifier"
          :match="match"
          :needScrollInvalidFeedback="needScrollInvalidFeedback"
          :scannedIdentifier="scannedIdentifier"
          @updateMatch="updateMatch"
          @updateNeedScroll="updateNeedScroll()"
        ></verify-match-step2>

      </div>
    </div>


    <div class="footer-create-annonce">
      <span class="fixed-bottom-100px span-step d-none d-md-block">{{
          $t('register.Step') + " " + currentStep + '/' + maxStep
        }}</span>
      <b-progress :max="maxStep" :value="currentStep" class="custom-progress-bar-no-radius" height="1em"
                  variant="primary"></b-progress>
      <div class="row h-100">
        <div class="col-md-12  d-flex align-items-center mb-2 ml-2 mr-2 justify-content-around">
          <b-button ref="btnPrevStep"
                    :disabled="currentStep===1"
                    class="mr-1" variant="secondary"
                    @click="prevStep">
            <div class="pr-3 pl-3">{{ currentStep > 1 ? $t('Previous') : $t('Back') }}</div>
          </b-button>
          <span class="span-step d-block d-md-none ">{{ currentStep + ' / ' + maxStep }}</span>
          <b-button ref="btnNextStep" class="mr-1" variant="primary" @click="nextStep">
            <div v-if="!isLoading" class="pr-4 pl-4">
              {{ currentStep === maxStep ? $t('Finish') : $t('Next') }}
            </div>
            <b-spinner v-else class="button-spinner"></b-spinner>
          </b-button>
        </div>
      </div>
    </div>

    <MatchDoneModal
      :did-insist="didInsist"
      @onAddRIBClicked="goToUserProfile"
      @onEndClicked="goBack"
    ></MatchDoneModal>

  </b-container>

</template>

<script>
import api from "../../services/api";
import BackArrow from "../../components/b122/BackArrow";
import VerifyMatchStep1 from "./VerifyMatchStep1";
import VerifyMatchStep2 from "./VerifyMatchStep2";
import MatchDoneModal from "./MatchDoneModal";
import i18n from "../../i18n";

export default {
  components: {
    BackArrow,
    VerifyMatchStep1,
    VerifyMatchStep2,
    MatchDoneModal
  },

  data() {
    return {
      scannedIdentifier: this.$route.params.scannedIdentifier,
      didInsist: this.$route.params.didInsist,
      identifier: this.$route.params.identifier,
      lat: this.$route.params.lat,
      lng: this.$route.params.lng,
      needScrollInvalidFeedback: false,

      currentStep: 1,
      maxStep: 2,

      isLoading: false,

      vehicleFiles: [],
      imagesInvalidState: null,

      match: {
        address: {state: null, invalidFeedback: null, value: null, mandatory: true},
        vehicleType: {state: null, invalidFeedback: null, value: null, mandatory: true},
        brand: {state: null, invalidFeedback: null, value: null, mandatory: true},
        model: {state: null, invalidFeedback: null, value: null, mandatory: true},
        VIN: {state: null, invalidFeedback: null, value: null, mandatory: false},
        color: {state: null, invalidFeedback: null, value: null, mandatory: true},
        energy: {state: null, invalidFeedback: null, value: null, mandatory: false},
        modelFinish: {state: null, invalidFeedback: null, value: null, mandatory: false},
        description: {state: null, invalidFeedback: null, value: null, mandatory: false},
      }
    };
  },

  mounted() {
    if ((this.scannedIdentifier.latitude && false) || (this.scannedIdentifier.longitude && false)) {
      this.scannedIdentifier.latitude = this.lat
      this.scannedIdentifier.longitude = this.lng
    }
  },

  methods: {

    updateNeedScroll() {
      this.needScrollInvalidFeedback = false
    },
    prevStep() {
      if (this.currentStep > 1) {
        this.currentStep--
      }
    },

    nextStep() {
      if (this.currentStep < 2) {
        if (this.vehicleFiles.length > 0) {
          this.currentStep++
        } else {
          this.imagesInvalidState = false
        }
      } else {
        if (!this.isLoading) {
          this.checkFormIntegrity()
        }
      }
    },

    onVehicleFilesUpdated(files) {
      this.imagesInvalidState = null
      this.vehicleFiles = files
    },

    updateMatch(match) {
      this.match = {...match}
    },

    checkFormIntegrity() {
      let formIsValid = true
      Object.keys(this.match).forEach((key) => {
        if (this.match[key] && this.match[key].mandatory && this.match[key].value == null) {
          this.match[key].state = false
          this.match[key].invalidFeedback = this.$i18n.t('MandatoryField')
          formIsValid = false
        }
      })

      if (formIsValid) {
        this.sendMatchVerification()
      } else {
        this.needScrollInvalidFeedback = true
      }
    },

    async sendMatchVerification() {
      const matchData = Object.keys(this.match).reduce((acc, key) => {
        if (this.match[key] && this.match[key].value !== null) {
          acc[key] = this.match[key].value
        }
        return acc
      }, {});

      let formData = new FormData()
      formData.append('match', JSON.stringify(matchData))
      formData.append('scannedIdentifier', JSON.stringify(this.scannedIdentifier))

      formData.append('nbImagesVehicle', this.vehicleFiles.length)
      this.vehicleFiles.forEach((file, index) => {
        formData.append(`imagesVehicle[${index}]`, file.file)
      });

      this.isLoading = true;

      await api({
        method: 'POST',
        url: `/matchAnnonce/saveMatchAnnonceGrandPublic`,
        data: formData
      })
        .then(async (response) => {
          this.$bvModal.show('match-done-modal')
        })
        .catch(error => {
          this.isLoading = false;
          this.$bvToast.toast(this.$i18n.t('Error'), {
            title: this.$i18n.t('Error.title'),
            autoHideDelay: 4000,
            toaster: 'b-toaster-bottom-right',
            solid: true
          })
          if (!error.response) {
            console.log("error", error)
          }
        })
    },

    goToUserProfile() {
      this.$router.replace({name: "ProfileEdit"})
    },

    goBack() {
      this.$router.go(-1)
    },
  },

};
</script>

<style>
/* pour affichage desktop (md) : scroll pas sur la page entière mais sur le contenu modifiable uniquement */
@media (min-width: 769px) {

  #verify-match-container {
    height: calc(89vh - 100px);
    max-height: calc(89vh - 100px);
  }

  #verify-match-title-container {
    height: 100px;
  }

  #verify-match-sub-container {
    height: calc(100% - 100px);
  }

  #verify-match-sub-container-right {
    height: 100%;
  }
}

@media (max-width: 768px) {
  #verify-match-sub-container-right {
    margin-bottom: 100px;
  }
}

.save-draft-icon-mobile {
  align-self: start;
  padding-top: 6px;
}

.active-draft {
  color: var(--main-green-medium);
}

.custom-span-data {
  display: none;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.2em;
  max-height: 3.6em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
}

@media (min-width: 769px) {


  .custom-span-data {
    display: block;
    width: 33%;
    color: var(--main-grey-medium);
  }
}

.custom-width {
  width: 50%;
}

.col-title {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer-create-annonce {
  background-color: var(--main-black-dark);
  position: fixed;
  left: 0;
  bottom: -1px;
  width: 100%;
  height: 100px;
  z-index: 10;
}

.fixed-bottom-100px {
  position: fixed;
  left: 0;
  bottom: 105px;
  z-index: 10;
  margin-left: 5em;
}


.span-step {
  color: var(--main-grey-medium);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.button-spinner.spinner-border {
  margin-left: calc(1.5rem + 28px - 0.5rem);
  margin-right: calc(1.5rem + 28px - 0.5rem);
}

@media (max-width: 768px) {

  .custom-width {
    width: 100%;
  }


  .col-title {
    display: flex;
    flex-direction: column;
    align-content: flex-start;
    justify-content: flex-start;
    align-items: flex-start;
  }

}
</style>



// WEBPACK FOOTER //
// src/views/match/VerifyMatch.vue